/**
 * The Steps tab in read mode (E1 viewer; SA-459 spec §5): `MapList`'s rows in
 * reading order, grouped by lane — the same row as the map's narrow
 * fallback — each opening the step drawer through `onSelect`. Nothing is
 * marked selected: the drawer overlays the page.
 */
import type { ProcessOverviewVM } from '@/utils/workflowOverview'
import { MapList } from '@/components/process/map/MapList'

const NONE = new Set<string>()

export function ProcessStepList({ vm, onSelect }: { vm: ProcessOverviewVM; onSelect: (id: string) => void }) {
  return <MapList vm={vm} currentStep={null} visited={NONE} onSelect={onSelect} />
}
